import React from 'react';
import AttachMoneyRoundedIcon from '@material-ui/icons/AttachMoneyRounded';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import yellow from '@material-ui/core/colors/yellow';

const getStageColor = (paidStages, heldStages, stagesToCheck) => {
    let colorChoice = grey[500]; // default

    if (paidStages.some(s=> stagesToCheck.indexOf(s) >= 0)) {
        colorChoice = green[500]
    } else if (heldStages.some(s=> stagesToCheck.indexOf(s) >= 0)) {
        colorChoice = yellow[400];
    }

    return colorChoice;
}

// Returns the stages each money icon (after the always-present first stage) should
// check for, ordered first -> final. Supports 2 through 5 payment stages.
const getStagedIconChecks = (numberOfPaymentStages) => {
    if (numberOfPaymentStages <= 1) {
        return [];
    }
    // Vision sends 2 stage second payment as second but Defi sends those as final so check for either
    if (numberOfPaymentStages === 2) {
        return [['second', 'final']];
    }
    // 3+ stages: the intermediate stages in order, followed by the final stage
    const intermediateStages = ['second', 'third', 'fourth'].slice(0, numberOfPaymentStages - 2);
    return [...intermediateStages.map(stage => [stage]), ['final']];
}

const FundingStagesCell = (props) => {
    const { paidStages = [], heldStages = [], hasStagedFunding = false, numberOfPaymentStages = 3} = props;

    // Keep every dollar sign on a single row, and tighten the gap between icons
    // (the icon SVG has built-in padding, so a small negative margin pulls them in).
    const iconStyle = { width: '20px', margin: '0 -4px', pointerEvents: 'none' };

    return (
        <div style={{ display: 'inline-flex', flexWrap: 'nowrap', whiteSpace: 'nowrap', alignItems: 'center' }}>
            <AttachMoneyRoundedIcon style={{ ...iconStyle, color: getStageColor(paidStages, heldStages, ['unstaged', 'first']) }} />
            {
                hasStagedFunding ?
                    getStagedIconChecks(numberOfPaymentStages).map((stagesToCheck) =>
                        <AttachMoneyRoundedIcon key={stagesToCheck.join('-')} style={{ ...iconStyle, color: getStageColor(paidStages, heldStages, stagesToCheck) }} />
                    ) :
                    null
            }
        </div>
    );
}

export default FundingStagesCell;